
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_qk1j1_1g0ih_145",
  "textarea": "awsui_textarea_qk1j1_1g0ih_149",
  "textarea-readonly": "awsui_textarea-readonly_qk1j1_1g0ih_199",
  "textarea-invalid": "awsui_textarea-invalid_qk1j1_1g0ih_241",
  "textarea-warning": "awsui_textarea-warning_qk1j1_1g0ih_250"
};
  